module.exports = __webpack_public_path__ + "static/media/Img_21.06ecec5e.JPG";